import { CircularProgress } from '@mui/material';

const CardLoader = (props: { size?: 'small' | 'medium' | 'large' }) => {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <CircularProgress size={props.size === 'small' ? 20 : props.size === 'medium' ? 40 : 60} />
    </div>
  );
};
export default CardLoader;
